import UnvisibleIcon from '@rsuite/icons/Unvisible';
import VisibleIcon from '@rsuite/icons/Visible';
import { FlexboxGrid, IconButton, Slider } from 'rsuite';

export interface SkillEditModel {
    id: number;
    name: string;
    level?: number;
    show_on_cv: boolean;
}

const SkillEdit = ({
    skill,
    skillIndex,
    changeSkillLevel,
    changeVisibility,
}: {
    skill: SkillEditModel;
    skillIndex: number;
    changeSkillLevel: (index: number, level: number) => void;
    changeVisibility: (index: number, visible: boolean) => void;
}) => {
    const noSkillLevel = !skill.level || skill.level === 0;

    const renderSkillMark = (mark: number) => {
        const SkillLevelDictionary: { [key: number]: string } = {
            0: 'None',
            20: 'Intermediate',
            50: 'Advanced',
            90: 'Expert',
        };
        return (
            <span style={{ color: mark === 0 ? 'lightgray' : 'gray' }}>
                {SkillLevelDictionary[mark]}
            </span>
        );
    };

    return (
        <FlexboxGrid.Item key={skillIndex} colspan={12} style={{ marginBottom: 20 }}>
            <FlexboxGrid>
                <FlexboxGrid.Item style={{ paddingTop: 3 }}>
                    {!skill.show_on_cv ? (
                        <IconButton
                            size="sm"
                            appearance="primary"
                            color="red"
                            disabled={noSkillLevel}
                            icon={<UnvisibleIcon />}
                            onClick={() => changeVisibility(skillIndex, true)}
                            alt="Show on CV"
                        />
                    ) : (
                        <IconButton
                            size="sm"
                            appearance="subtle"
                            color="green"
                            disabled={noSkillLevel}
                            icon={<VisibleIcon />}
                            onClick={() => changeVisibility(skillIndex, false)}
                            alt="Hide on CV"
                        />
                    )}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item>
                    <h4 style={{ paddingLeft: 5 }}>{skill.name}</h4>
                </FlexboxGrid.Item>
            </FlexboxGrid>
            <p style={{ height: 15, textAlign: 'center' }}>
                {skill.level ? `${skill.level}%` : null}
            </p>
            <div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}>
                <Slider
                    style={{ marginLeft: 20 }}
                    defaultValue={skill.level ?? 0}
                    min={0}
                    step={10}
                    max={100}
                    graduated
                    progress
                    tooltip={false}
                    renderMark={mark => renderSkillMark(mark)}
                    onChange={value => changeSkillLevel(skillIndex, value)}
                />
            </div>
        </FlexboxGrid.Item>
    );
};

export default SkillEdit;
